import React from 'react';
import useTranslation from 'hooks/use-translation';
import { SidebarFiltersSection } from 'components/sidebar-filters';
import useUI from 'hooks/use-ui';
import { useCategorySubcategoryFilter } from './use-category-subcategory-filter';
import { CategorySubcategories } from './types';
import { CategoriesList } from './categories-list';

export type CategorySubcategoryFilterProps = {
  categoriesSubcategories: CategorySubcategories[] | null;
  /**
   * When true, clicking a category navigates via URL (path-routed category pages)
   * instead of updating the `category` query param. See PF-9862.
   */
  navigateOnCategoryClick?: boolean;
};

export function CategorySubcategoryFilter({
  categoriesSubcategories,
  navigateOnCategoryClick,
}: CategorySubcategoryFilterProps): JSX.Element {
  const { t } = useTranslation();
  const {
    selectedCategory,
    selectedSubcategories,
    handleClickCategory,
    handleClickSubcategoryMultiSelect,
  } = useCategorySubcategoryFilter({ navigateOnCategoryClick });
  const { onCollectionsPage } = useUI();

  return (
    <SidebarFiltersSection collapsible={onCollectionsPage} heading={t('common.category_plural', 'Categories')}>
      <CategoriesList
        categoriesSubcategories={categoriesSubcategories}
        selectedCategory={selectedCategory}
        selectedSubcategories={selectedSubcategories}
        handleClickCategory={handleClickCategory}
        handleClickSubcategoryMultiSelect={handleClickSubcategoryMultiSelect}
      />
    </SidebarFiltersSection>
  );
}
